import { LitElement, html } from "lit-element";
import { SharedStyles } from "../styles/shared-styles";
import { connect } from "pwa-helpers/connect-mixin.js";
import { store } from "../inspx-store.js";
import "./text-box.js";

export class OutputField extends connect(store)(LitElement) {
	render() {
		return html`
			${SharedStyles}
			<text-box type="text" .label="${this._label}" .value="${this._value}" disabled="true"></text-box>
			`;
	}

	constructor(prop) {
		super();

		this._label = prop.title;
		this._value = "";

		const eval2 = eval; //this is workaround for rollup (https://github.com/rollup/rollup/wiki/Troubleshooting#avoiding-eval)
		this._func = prop.func ? eval2("(" + prop.func + "\n)") : null;
	}

	static get properties() {
		return {
			_label: { type: String },
			_value: { type: String },
			localContext: { type: Object }
		};
	}

	stateChanged(state) {
		const insp = state.inspection.current || (state.inspection.remote ? state.inspection.remote.inspection : null);
		if (typeof this._func === "function") {
			const v = this._func(insp, this.localContext);
			if (v !== this._prevValue) {
				this._value = this._prevValue = v;
			}
		}
	}
}

window.customElements.define("inspx-output-field", OutputField);
